﻿const { css } = require("jquery");

window.setupFormToggle = function () {

    var frm = document.querySelector('.pod__form');
    var btns = document.querySelectorAll('.btn-toggle');

    console.log('g');

    var cssClass = "expanded";

    if (frm != null && btns != null) {
        btns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                if (frm.classList.contains(cssClass)) {
                    frm.classList.remove(cssClass);
                } else {
                    frm.classList.add(cssClass);
                    // hide the button as it isn't really a toggle
                    btn.style.display = 'none';
                }
            })
        })
    }
}


if (document.readyState !== 'loading') {
    window.setupFormToggle();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        window.setupFormToggle();
    });
}


